import { Button, IconButton, TableCell, TableRow } from '@mui/material';
import { CreateTagDto, TagDto, UpdateTagDto } from '@sr/dto';
import { useCreateTag, useDeleteTag, useTags, useUpdateTag } from 'entities/tag/lib/tags.hook';
import { Tag } from 'entities/tag/ui/tag';
import { TagFormFields } from 'features/tag/ui/tag.form-fields';
import { usePagingParams } from 'shared/hooks/paging-params';
import { GridLayout } from 'shared/ui/grid-layout';
import AddIcon from '@mui/icons-material/Add';
import { useSnack } from 'shared/ui/snack';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { useCreateOrEditDialog } from 'hooks/create-or-edit-dialog.hook';
import { formTools, FormValues, TagsNotificationsConfig } from 'features/tag/tag.form-tools';
import { FormDialog } from 'shared/ui/form-dialog';
import { ErrorBanner } from 'shared/ui/error-banner';

const columns = ['Номер', 'Тэг', 'Связанные сущности', ''];
type RowProps = {
  tag: TagDto;
  deleteTag: (id: number) => void;
  editTag: () => void;
};

const Row = ({ tag, deleteTag, editTag }: RowProps) => {
  return(
    <TableRow>
      <TableCell>{tag.id}</TableCell>
      <TableCell>
        <Tag tag={tag} />
      </TableCell>
      <TableCell >Not implemented</TableCell>
      <TableCell align='right'>
        <IconButton size='small' onClick={() => editTag()}>
          <EditIcon />
        </IconButton>
        <IconButton size='small' onClick={() => deleteTag(tag.id)}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
export const SettingsTags = () => {
  const [paging, setPaging] = usePagingParams();
  const { isLoading, items, error, totalItemsCount } = useTags(paging);
  const { showError, showSuccess } = useSnack();
  const showConfirm = useConfirmDialog();
  const deleteTag = useDeleteTag();

  const create = useCreateTag();
  const update = useUpdateTag();

  const {
    dialogProps,
    openToAdd,
    openToEdit,
    itemToEdit
  } = useCreateOrEditDialog<TagDto, CreateTagDto, UpdateTagDto, FormValues>({
    addHandler: async (dto: FormValues) => {
      await create(formTools.toCreateDto(dto));
    },
    updateHandler: async (dto: FormValues) => {
      if (!itemToEdit) return;
      await update(formTools.toUpdateDto(itemToEdit.id, dto));
    },
    formTools,
    notificationsConfig: TagsNotificationsConfig
  });

  const handleDelete = async (id: number) => {
    try {
      await showConfirm({ content: 'Вы уверены, что хотите удалить тег?' });
      await deleteTag(id);
      showSuccess('Тег удален');
    } catch (error) {
      showError(`Ошибка удаления тега: ${extractNestJsErrorMessage(error)}`);
    }
  };
  
  if (error) {
    return <ErrorBanner errorMessage={error} />;
  }

  return <>
    <Button sx={{ mb: 3, mt: 2 }} variant='contained' size='small' startIcon={<AddIcon />} onClick={() => openToAdd()}>Добавить тег</Button>
    <GridLayout
      columns={columns}
      isLoading={isLoading}
      pagingData={paging}
      onChangePaging={setPaging}
      totalItemsCount={totalItemsCount}
      items={items}
      noItemsText='Нет тегов'
      itemRender={(item) => <Row key={item.id} tag={item} deleteTag={handleDelete} editTag={()=> openToEdit(item)}/>}
    />

    <FormDialog<FormValues> {...dialogProps} renderTitle={!itemToEdit ? 'Новый тег' : 'Редактировать тег'} renderForm={(props) => <TagFormFields {...props} />} />
      
  </>;
};


